import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-amber-700 text-xs tracking-[0.3em] uppercase mb-3">{t('contact_tag')}</p>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('contact_title')}
          </h2>
        </div>
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-start">
          <div className="w-full lg:w-1/3 flex flex-col gap-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-amber-50 rounded-full shrink-0">
                <i className="ri-map-pin-line text-amber-700" />
              </div>
              <div>
                <p className="text-xs md:text-sm font-semibold text-gray-800 mb-1">{t('contact_address_label')}</p>
                <p className="text-xs md:text-sm text-gray-500 leading-relaxed whitespace-pre-line">{t('contact_address')}</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-amber-50 rounded-full shrink-0">
                <i className="ri-phone-line text-amber-700" />
              </div>
              <div>
                <p className="text-xs md:text-sm font-semibold text-gray-800 mb-1">{t('contact_phone_label')}</p>
                <p className="text-xs md:text-sm text-gray-500">TEL: 02) 2277-1141~4</p>
                <p className="text-xs md:text-sm text-gray-500">FAX: 02) 2275-1443</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-amber-50 rounded-full shrink-0">
                <i className="ri-mail-line text-amber-700" />
              </div>
              <div>
                <p className="text-xs md:text-sm font-semibold text-gray-800 mb-1">{t('contact_email_label')}</p>
                <a href="mailto:youngbinhotel@hotmail.com" className="text-xs md:text-sm text-amber-700 hover:underline cursor-pointer">
                  youngbinhotel@hotmail.com
                </a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-amber-50 rounded-full shrink-0">
                <i className="ri-time-line text-amber-700" />
              </div>
              <div>
                <p className="text-xs md:text-sm font-semibold text-gray-800 mb-1">{t('contact_checkinout_label')}</p>
                <p className="text-xs md:text-sm text-gray-500">{t('contact_checkin')}</p>
                <p className="text-xs md:text-sm text-gray-500">{t('contact_checkout')}</p>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-2/3 rounded-lg overflow-hidden h-80">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.0!2d127.0!3d37.56!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca2f0a0a0a0a0%3A0x0!2z7IOB67KE6rWQ6rO87JuQ!5e0!3m2!1sko!2skr!4v1"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Youngbin Hotel Location"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
